import React, {useState} from 'react';
import { ScrollRestoration, useLoaderData } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getExcursionTerms } from "server/getExcursionTerms";
import SEO from "components/SEO/SEO";


//CSS
import styles from "./excursionTerms.module.less"

export async function loader({ params }) {

  const response = await getExcursionTerms(params.id, params.language);

  if(process.env.REACT_APP_DEBUG === 'true') console.log("[EXCURSION TERMS] -> Loader");
  if(process.env.REACT_APP_DEBUG === 'true') console.log("response", response);

  if (!response.error){
    return response.data;
  }else{
    throw new Error("Loader excursión:", { cause: response.error })
  }
}

export default function ExcursionTerms() {
  const excursionTermns = useLoaderData();
  const {t} = useTranslation("excursionterms");

  return(
    <>
      <SEO title={t('Términos y condiciones')} description={t('Término y condiciones espècificos de una excursión')} name='Viajes Teide' type='page' />

      <div className={styles.termsContent}>
        {excursionTermns.name &&
          <h1>{excursionTermns.name}</h1>
        }

        {excursionTermns.termsconditions &&
          <>
            <h2>{t('Términos y condiciones de la excursión')}</h2>
            <div className={styles.text} dangerouslySetInnerHTML={{__html: excursionTermns.termsconditions}}></div>
          </>
        }

        {excursionTermns.cancellationpolicy &&
          <>
            <h2>{t('Cambios y cancelaciones')}</h2>
            <div className={styles.text} dangerouslySetInnerHTML={{__html: excursionTermns.cancellationpolicy}}></div>
          </>
        }
      </div>

      <ScrollRestoration />
    </>
  )
}


